import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=a235ce2c&scoped=true&"
var script = {}
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=a235ce2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a235ce2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
